import React from "react";
import "./WhyWeStandOut.css";

import img1 from "../Assets/tutors.png"; // replace with your image path
import img2 from "../Assets/hands-on.jpeg"; // replace with your image path
import img3 from "../Assets/online.png"; // replace with your image path
import dotPattern from "../Assets/Triangle.png"; // your dot image

const WhyWeStandOut = () => {
  return (
    <section className="wso-section">
      <div className="wso-header">
        <h2>The Newzeal Difference — Built to Stand Apart</h2>
        <img src={dotPattern} alt="Dot pattern" className="wso-dots" />
      </div>

      <div className="wso-cards">
        <div className="wso-card">
          <img src={img1} alt="Skilled Tutors" />
          <h3>Skilled Teachers. Confident Students</h3>
          <p>
           At Newzeal, skilled teachers go beyond instruction — they mentor, guide, and inspire. With practical methods and personal support, they turn learning into confidence, helping every student succeed in studies and beyond.
          </p>
        </div>

        <div className="wso-card">
          <img src={img2} alt="Hands-On Practice" />
          <h3>Real-World Practice Over Bookish Knowledge</h3>
          <p>
           At Newzeal, learning goes beyond textbooks. We focus on real conversations and everyday scenarios, so you build practical skills and the confidence to speak from day one.
          </p>
        </div>

        <div className="wso-card">
          <img src={img3} alt="Learn Online" />
          <h3>Flexible Online Learning — From the Comfort of Home</h3>
          <p>
            At Newzeal, learning is designed to be flexible and convenient. Whether you’re working, freelancing, preparing for exams or planning to study overseas, our online English classes adapt to your timetable — all from the comfort of home.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyWeStandOut;
